class KeycloakService {
    constructor() {
        'ngInject';
    }

    setAppContext(appContext) {
        this.appContext = appContext;
    }

    initKeycloak(realm, url, clientId) {
        window.keycloakServiceInstance = this;
        window.keycloakInstance = new Keycloak({
            "realm": realm,
            "url": url,
            "clientId": clientId,
            "resource": "doclr-vg-agenda-legacy-client",
            "public-client": true,
            "confidential-port": 0
        });
        return window.keycloakInstance.init({
            onLoad: 'check-sso',
            silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html'
        }).then((authenticated) => {
            if (!authenticated) {
                window.keycloakInstance.login();
            } else {
                window.setInterval(() => this.scheduleRefresh(), 20000);
            }
        }).catch(function (e) {
            alert('failed to initialize');
        });
    }

    logout() {
        window.keycloakInstance.logout({
            redirectUri: window.location.origin + '/kclogin'
        });
    }

    getToken() {
        return window.keycloakInstance.token;
    }

    updateToken() {
        return window.keycloakInstance.updateToken(10)
            .catch(() => this.retryLogin());
    }

    retryLogin() {
        window.keycloakInstance.login();
    }

    scheduleRefresh() {
        try {
            window.keycloakInstance.updateToken(30).catch(() => {
                this.retryLogin();
            });
        } catch (ex) {
            this.retryLogin();
        }
    }
}

(function () {
    'use strict';

    angular.module('doclr.keycloak')
        .service('KeycloakService', KeycloakService);
})();